import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { PageLayout } from '../layouts/PageLayout';
import { SEOHead } from '../components/seo/SEOHead';
import { buildPersonSchema, SITE } from '../utils/seo';
import { useMarkdown } from '../hooks/useMarkdown';

export function About() {
  const { frontmatter, content, loading, error } = useMarkdown('/content/about.md');
  const description = frontmatter.description || SITE.description;

  return (
    <PageLayout>
      <SEOHead
        title="About"
        description={description}
        canonical={`${SITE.url}/about`}
        jsonLd={[buildPersonSchema()]}
      />

      <article className="prose-custom max-w-2xl">
        <header className="mb-8">
          <h1 className="font-serif text-4xl text-[var(--color-text)] mb-2">
            {frontmatter.title || 'About'}
          </h1>
          {frontmatter.description && (
            <p className="text-[var(--color-muted)] text-lg">{frontmatter.description}</p>
          )}
        </header>

        {loading && <p className="text-[var(--color-muted)] animate-pulse">Loading…</p>}
        {error   && <p className="text-red-400 text-sm">Content unavailable.</p>}
        {!loading && !error && (
          <div className="markdown-body">
            <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
          </div>
        )}
      </article>
    </PageLayout>
  );
}
